<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <component :is="displayedComponent" v-model:component="component" />
  </div>
</template>
